import React from 'react';
import Icon1 from '../../images/icon1.jfif';
import Icon2 from '../../images/icon2.png';
import Icon3 from '../../images/icon3.jpg';
import {
    ServicesContainer,
    ServicesH1,
    ServicesWrapper,
    ServicesCard,
    ServicesIcon,
    ServicesH2,
    ServicesP
} from './ServicesElements';

const Services = () => {
    return (
        <ServicesContainer id="services">
            <ServicesH1>We Strongly Belive In Customers Satisfaction </ServicesH1>
            <ServicesWrapper>
                <ServicesCard>
                    <ServicesIcon src={Icon1} />
                    <ServicesH2>All mechanical work</ServicesH2>
                    <ServicesP>Provide all type of mechanical work services</ServicesP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesIcon src={Icon2} />
                    <ServicesH2>Car Washing & Car Decore</ServicesH2>
                    <ServicesP>Provice car Washing and car decoration items</ServicesP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesIcon src={Icon3} />
                    <ServicesH2>Car Broker</ServicesH2>
                    <ServicesP>Buying and selling used cars on Commission basis</ServicesP>
                </ServicesCard>
            </ServicesWrapper>
        </ServicesContainer>
    )
}

export default Services
